<div class="date-range-picker" [ngStyle]="{ gap: isChooseDateRangeSelected ? '10px' : 'inherit' }">
  <ng-select
    [formControl]="datesDropdownControl"
    [id]="'enumDatesDropdownType'"
    [placeholder]="'FORM_PLACEHOLDER.DATES' | translate"
    class="date-range-picker__dropdown"
    [items]="datesItems"
    [multiple]="false"
    [clearable]="clearable"
    [searchable]="searchable"
    [bindLabel]="'label'"
    [bindValue]="'value'"
  ></ng-select>

  <app-control-wrapper
    [classGroup]="isChooseDateRangeSelected ? 'm-0' : 'm-0 d-none'"
    [control]="wrapperFc || fc"
    [errors]="errors"
    [helper]="helper"
    [errorsOverrideParams]="errorsOverrideParams"
    [isShowHelper]="showHelper"
  >
    <label *ngIf="label" [for]="id" control-label [ngClass]="labelClass">
      {{ label | translate }}
      <i *ngIf="required" class="fa fa-asterisk form-required" aria-hidden="true"></i>
    </label>
    <div class="input-wrapper" control-wrapper [ngClass]="{ 'with-icon': isWithIcon }">
      <span class="calendar-icon" *ngIf="isWithIcon">
        <i class="fa fa-calendar"></i>
      </span>
      <input
        #inputElement
        #dp="bsDaterangepicker"
        bsDaterangepicker
        type="text"
        class="form-control"
        [id]="id"
        [name]="name"
        [bsConfig]="{
          containerClass: 'dates-selection-container custom-theme',
          showWeekNumbers: false,
          adaptivePosition: true,
          isAnimated: true,
          customTodayClass: showCurrentDate ? 'today' : null
        }"
        [ngClass]="{ 'with-icon': isWithIcon }"
        [maxDate]="maxDateFormatted"
        [minDate]="minDateFormatted"
        [placeholder]="placeholder ? (placeholder | translate) : ''"
        [disabled]="isShowDisabled && fc.disabled"
        [(ngModel)]="dateRangeValue"
        (bsValueChange)="onDatePickerChange($event, dp)"
        (onShown)="onShown(dp)"
      />
    </div>
  </app-control-wrapper>
</div>
